import { Box, Typography } from "@mui/material";
import { useMemo } from "react";

export type TopWashTypesChartProps = {
  data: {
    key: string;
    numberOfWashes: number;
  }[];
};

const BAR_COLORS = ["#A7C7E7", "#CDB4DB", "#B7E4C7", "#FFD6A5", "#FFADAD"];

export const TopWashTypesChart = ({ data }: TopWashTypesChartProps) => {
  const sortedData = useMemo(
    () =>
      [...data].sort((a, b) => b.numberOfWashes - a.numberOfWashes).slice(0, 5),
    [data],
  );

  const maxValue = (sortedData[0]?.numberOfWashes || 1) * 1.2;

  return (
    <Box
      sx={{
        minHeight: { xs: 0, sm: 420 },
        height: { xs: "auto", sm: 420 },
        p: { xs: 2, sm: 3 },
        borderRadius: "18px",
        backgroundColor: "#fff",
        boxShadow: "0px 2px 12px rgba(0,0,0,.08)",
      }}
    >
      <Typography
        sx={{
          fontSize: 18,
          fontWeight: 700,
          mb: 0.5,
        }}
      >
        Common Service Tiers
      </Typography>

      <Typography
        sx={{
          fontSize: 14,
          color: "#94A3B8",
          mb: { xs: 3, sm: 4 },
        }}
      >
        Highest frequency wash types
      </Typography>

      {sortedData.map((item, index) => (
        <Box key={item.key} sx={{ mb: 2 }}>
          <Box display="flex" justifyContent="space-between" gap={1} mb={1}>
            <Typography fontWeight={500} sx={{ overflowWrap: "anywhere" }}>
              {item.key}
            </Typography>

            <Typography fontWeight={700}>{item.numberOfWashes}</Typography>
          </Box>

          <Box
            sx={{
              height: 10,
              backgroundColor: "#EEF2F7",
              borderRadius: 999,
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: `${(item.numberOfWashes / maxValue) * 100}%`,
                backgroundColor: BAR_COLORS[index % BAR_COLORS.length],
                borderRadius: 999,
              }}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};
